import enums from '../enums.js';

const componentNames = ['navigate'];
const config = {
  expressions: [
    enums.expressions.PRIMARY,
    enums.expressions.SECONDARY
  ],
  interactions: [
    enums.interactions.FOCUSED,
    enums.interactions.HOVERED,
    enums.interactions.CHOSEN
  ],
  styleProperties: [
    enums.properties.BACKGROUND_COLOR,
    enums.properties.FOREGROUND_COLOR,
    enums.properties.BORDER_COLOR,
    enums.properties.OUTLINE_COLOR,
    enums.properties.BORDER_RADIUS,
    enums.properties.TEXT_DECORATION
  ]
};

export default componentNames.reduce((obj, name) => Object.assign(obj, { [name]: config }), {});
